import PropTypes from '@viking-eng/prop-types';
import { getAccessibilityFunctions, getScreenTier, LinkOrAnchor } from '@viking-eng/utils';
import $ from 'jquery';
import React from 'react';
import './Menu.css';

class Menu extends React.Component {
  constructor(props) {
    super(props);

    this.handleFocus = this.handleFocus.bind(this);
  }

  componentDidMount() {
    const { id } = this.props;
    const screenTier = getScreenTier();
    $(document).on('click touch', (e) => {
      if (screenTier === 'extra-small' && !e.target.closest('#hamburger-menu')) {
        document.body.classList.remove('left-menu-open');
      }
      const isiOS = !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
      if (isiOS) {
        $('body').css('cursor', 'pointer');
      }
      const menuSelector = document.getElementById(id);
      if (menuSelector) {
        menuSelector.classList.remove('show');
      }
    });

    document.addEventListener('focusin', this.handleFocus);
  }

  handleFocus() {
    const { id } = this.props;

    if (document && document.activeElement && !document.activeElement.classList.contains('menu-item')) {
      const menuSelector = document.getElementById(id);
      if (menuSelector) {
        menuSelector.classList.remove('show');
      }
    }
  }

  render() {
    const { id, items, children, tabIndex } = this.props;

    const primaryMenuItems = items.filter((item) => item.isSmallText === 'false');
    const secondaryMenuItems = items.filter((item) => item.isSmallText === 'true');
    return (
      <div className="menu">
        {children}
        <div className="menu-collapse collapse" id={id}>
          {primaryMenuItems &&
            primaryMenuItems.length > 0 &&
            primaryMenuItems.map((item) => (
              <LinkOrAnchor
                {...getAccessibilityFunctions()}
                className="row menu-row menu-items-divider menu-item"
                data-dismiss={item['data-dismiss']}
                data-target={item['data-target']}
                data-toggle={item['data-toggle']}
                key={item.id}
                onClick={item.onClick ? () => item.onClick() : () => {}}
                rel="noopener noreferrer"
                tabIndex={tabIndex}
                target={item.openInNewWindow === 'true' ? '_blank' : ''}
                url={item.url}
              >
                {item.title}
              </LinkOrAnchor>
            ))}
          {secondaryMenuItems && secondaryMenuItems.length > 0 && (
            <div className="secondary-menu">
              {secondaryMenuItems.map((item) => (
                <LinkOrAnchor
                  {...getAccessibilityFunctions()}
                  className="row menu-items-row small-body-copy menu-item"
                  key={item.id}
                  onClick={item.onClick ? () => item.onClick() : () => {}}
                  rel="noopener noreferrer"
                  tabIndex={tabIndex}
                  target={item.openInNewWindow === 'true' ? '_blank' : ''}
                  url={item.url}
                >
                  {item.title}
                </LinkOrAnchor>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

Menu.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  items: PropTypes.menuItems.isRequired,
  tabIndex: PropTypes.string
};

Menu.defaultProps = {
  children: null,
  tabIndex: '1'
};

export default Menu;
